<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    class="icon-svg icon-instagram"
  >
    <title>Instagram logo</title>
    <g
      fill-rule="evenodd"
    >
      <path
     
        d="M26.166 7.622c-.797 0-1.444-.649-1.444-1.444 0-.798.647-1.446 1.444-1.446.796 0 1.445.648 1.445 1.446 0 .795-.649 1.444-1.445 1.444zM16 8.71c-4.02 0-7.29 3.27-7.29 7.29s3.27 7.288 7.29 7.288S23.29 20.02 23.29 16c0-4.019-3.27-7.289-7.29-7.289zm0 16.012c-4.81 0-8.722-3.913-8.722-8.723 0-4.809 3.912-8.72 8.722-8.72s8.722 3.912 8.722 8.72c0 4.81-3.912 8.723-8.722 8.723zM6.187 1.433c-2.622 0-4.754 2.133-4.754 4.753v19.628c0 2.62 2.132 4.753 4.754 4.753h19.626c2.622 0 4.754-2.133 4.754-4.753V6.186c0-2.62-2.132-4.752-4.754-4.752H6.187zM25.813 32H6.187C2.775 32 0 29.226 0 25.814V6.186C0 2.776 2.775 0 6.187 0h19.626C29.225 0 32 2.775 32 6.186v19.628C32 29.226 29.225 32 25.813 32z"
      />
    </g>
  </svg>
</template>
